/** Вид файла по-человечески. */
export function kindTitle(kind: string): string {
  switch (kind) {
    case 'image':
      return 'Картинка';
    case 'video':
      return 'Видео';
    case 'audio':
      return 'Аудио';
    default:
      return 'Документ';
  }
}

/** Вес файла — как его называют люди. */
export function humanSize(bytes: number): string {
  if (bytes < 1024) {
    return `${String(bytes)} Б`;
  }

  if (bytes < 1024 * 1024) {
    return `${String(Math.round(bytes / 1024))} КБ`;
  }

  if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(1)} МБ`;
  }

  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} ГБ`;
}
